export function selectCards() {
  return (state) => state.dashboard.cards;
}

export function selectCharts() {
  return (state) => state.dashboard.charts;
}

export function selectRecentControls() {
  return (state) => state.dashboard.recentControls;
}